/**
 * @file
 * Contains megamenu.js.
 */

(function (Drupal) {
  'use strict';

  Drupal.behaviors.megamenu = {
    attach: function (context, settings) {
      const mainMenu = document.querySelector('nav.menu--main');

      function openMegaMenu() {
        mainMenu.classList.add('opened');
      }

      function closeMegaMenu() {
        mainMenu.classList.remove('opened');
        document
          .querySelectorAll('li.menu-item--expanded')
          .forEach(function (item) {
            item.classList.remove('focused');
          });
      }

      // Basic a11y.
      // Make the megamenu navigable with keyboard.
      document
        .querySelectorAll(
          'ul.menu--simple-mega-menu li.menu-item--expanded > button, ul.menu--simple-mega-menu li.menu-item--expanded > a'
        )
        .forEach((element) => {
          element.addEventListener('touchend', openMegaMenu);
          element.addEventListener('mouseup', openMegaMenu);

          element.addEventListener('focusin', function () {
            // Remove 'focused' class from all li.menu-item--expanded
            document
              .querySelectorAll('li.menu-item--expanded')
              .forEach(function (item) {
                item.classList.remove('focused');
              });

            // Add 'focused' class to the parent li.menu-item--expanded of the focused element
            this.closest('li.menu-item--expanded').classList.add('focused');
          });
        });

      // Click event handler on body to close menu
      document
        .querySelector('button.back-menu')
        .addEventListener('click', closeMegaMenu);

      // Keyup event handler to close menu on escape key press
      document.addEventListener('keyup', function (e) {
        if (e.code === 'Escape') {
          // Remove 'focused' class from all li.menu-item--expanded
          document
            .querySelectorAll('li.menu-item--expanded')
            .forEach(function (item) {
              item.classList.remove('focused');
            });
        }
      });
    },
  };
})(Drupal);
